// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  serverUrl: 'https://mumsnmidwife.co.nz:8663/',
  countryFlagUrl: 'https://flagicons.lipis.dev/flags/4x3/',
  firebaseConfig : {
    apiKey: "AIzaSyDUSkr1h4_g_7bXWnL9GHhO6yX9cos_enw",
    authDomain: "mums-and-midwifes-uat.firebaseapp.com",
    databaseURL: "https://mums-and-midwifes-uat-default-rtdb.firebaseio.com",
    projectId: "mums-and-midwifes-uat",
    storageBucket: "mums-and-midwifes-uat.appspot.com",
    messagingSenderId: "313166358923",
    appId: "1:313166358923:web:5cba33ed0310791005278e",
    measurementId: "G-JMWZE7CRD3"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
